import { ButtonHTMLAttributes, FC, PropsWithChildren } from 'react';
import cn from 'utils/cn';

import { IDataTestId } from '../../../../../custom';
import ActionButton from '@3.0/ActionButtons/ActionButton/ActionButton';

const ControlBarButton: FC<
  PropsWithChildren & ButtonHTMLAttributes<HTMLButtonElement> & IDataTestId
> = (props) => {
  const { children, ...rest } = props;

  return (
    <ActionButton
      {...rest}
      testId={rest?.['data-testid'] || 'control-bar-button'}
      className={cn('tw:inline-flex tw:h-full tw:border-primary-600', rest.className)}
    >
      {children}
    </ActionButton>
  );
};

export default ControlBarButton;
